import React from 'react';
import './navbar.css';

const MobileNavbar = (props: any) => {
   return (
      <div className='navbar d-flex'>
         <div className='navbar-icon'>
            
               {
                  props.isMenuOpen ?
                  <div className='navbar-icon' onClick={() => props.setIsMenuOpen(false)}>
                     <div className='nb-open'>
                        <div className='nb-open-div nbo-div-1'>|M</div>
                        <div className='nb-open-div nbo-div-2'></div>
                     </div>
                  </div> :
                  <div className='navbar-icon' onClick={() => props.setIsMenuOpen(true)}>
                     <div className='nb-open'>
                        <div className='nb-close-div nbc-div-1'>X</div>
                        <div className='nb-close-div nbc-div-2'></div>
                     </div>
                  </div>
               }

               {

               }
         </div>
      </div>
   )
}

export default MobileNavbar
